// extracted by mini-css-extract-plugin
module.exports = {"minorTag":"clinical-portal-3__MarkAsSensitivePlugin__minorTag","radioButtonContainer":"clinical-portal-3__MarkAsSensitivePlugin__radioButtonContainer"};